// extracted by mini-css-extract-plugin
export var categoryLinks = "CategorySideNav-module--category-links--d5d6e";
export var categorySideNavWrapper = "CategorySideNav-module--category-side-nav-wrapper--9ac87";
export var header = "CategorySideNav-module--header--053cb";
export var iconWrapper = "CategorySideNav-module--icon-wrapper--b2b3b";
export var selected = "CategorySideNav-module--selected--109aa";